module.exports = __webpack_public_path__ + "static/media/dark_orange-theme.6f77f371.png";